import React, { useState } from "react";

import {
  AccessTimeOutlined,
  CalendarMonthOutlined,
  Circle,
  InsertDriveFileOutlined,
  KeyboardArrowDown,
  OpenInNewOutlined,
  Pause,
  PersonOutline,
  PlayArrow,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  ButtonBase,
  CircularProgress,
  Link,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import PROFILEICON from "../../../assets/icons/profile.png";

import Tooltip from "../../../common/Tooltip";
import {
  selectPostById,
  togglePostActiveOrInActive as togglePostActiveOrInActiveAction,
} from "../../../redux/slices/postsSlice";
import { flows } from "../../../static/data";
import { getCamelCaseWord } from "../../../utils/functions";
import JobCriteriaPopup from "../JobCriteriaPopup";

/* =============================================================================
<JobLiveTableViewRow />
============================================================================= */
const JobLiveTableViewRow = ({ post, togglePostActiveOrInActive }) => {
  console.log("Post data:", post); // Check if post exists
  console.log("Expiry date:", post?.expiry_date); // Check expiry date
  console.log("Created at:", post?.created_at); // Check created date

  console.log("=== DATE DEBUGGING ===");
  console.log("Raw expiry_date:", post?.expiry_date);
  console.log("Raw created_at:", post?.created_at);
  console.log(
    "dayjs expiry formatted:",
    post?.expiry_date ? dayjs(post.expiry_date).format("LL") : "No expiry date"
  );
  console.log(
    "dayjs created formatted:",
    post?.created_at ? dayjs(post.created_at).format("LL") : "No created date"
  );
  console.log(
    "dayjs expiry isValid:",
    post?.expiry_date ? dayjs(post.expiry_date).isValid() : false
  );
  console.log(
    "dayjs created isValid:",
    post?.created_at ? dayjs(post.created_at).isValid() : false
  );

  // Also check if dayjs is imported correctly
  console.log("dayjs function:", typeof dayjs);

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(post?.job_status);

  const handleStatusUpdate = async (_status) => {
    const oldStatus = status;
    try {
      setLoading(true);
      setStatus(_status);

      await togglePostActiveOrInActive({ job_id: post?.id, status: _status });
    } catch (e) {
      setStatus(oldStatus);
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  // console.log(post)
  return (
    <TableRow hover role="checkbox" tabIndex={-1}>
      <TableCell align="center">
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            minWidth="10px"
            minHeight="10px"
            borderRadius="50%"
            bgcolor="#25c661"
          />
          <Box>
            <Typography fontSize="14px" textAlign="left" fontWeight={600}>
              {post?.job_name}
            </Typography>
            <Tooltip
              title={
                <Box>
                  {post?.assessment?.tests?.map((test, index) => (
                    <Box display="flex" gap={1} mb={1} key={index}>
                      <InsertDriveFileOutlined
                        sx={{ width: "17px", height: "17px", color: "#4bc7e1" }}
                      />
                      <Box>
                        <Typography fontSize="13px">
                          {test.test_name}
                        </Typography>
                        <Typography fontSize="10px" color="#999">
                          {test.questions?.length || 0} questions
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              }
            >
              {post?.assessment?.tests?.length > 0 && (
                <Box display="flex" alignItems="center" gap={1}>
                  <InsertDriveFileOutlined
                    sx={{ width: "18px", color: "#888", height: "18px" }}
                  />
                  <Typography fontSize="13px" color="#888">
                    Assessments attached ({post?.assessment?.tests?.length}{" "}
                    Tests)
                  </Typography>
                </Box>
              )}
            </Tooltip>
          </Box>
        </Box>
      </TableCell>

      <TableCell>
        <Box display="flex">
          <Box
            sx={{
              bgcolor: post?.job_status === "active" ? "#E8F8FB" : "#FFECEC",
              borderRadius: "30px",
              px: 2,
              py: 1,
            }}
          >
            <Typography
              color={post?.job_status === "active" ? "#56CAE3" : "#FF7070"}
              fontSize="13px"
              fontWeight={600}
            >
              {getCamelCaseWord(post?.job_status)}
            </Typography>
          </Box>
        </Box>
      </TableCell>
      <TableCell>
        <Box display="flex">
          <Box
            sx={{
              bgcolor: flows[post?.flow]?.bgcolor || "#FFECEC",
              borderRadius: "30px",
              px: 2,
              py: 1,
            }}
          >
            <Typography
              noWrap
              color={flows[post?.flow]?.color || "#FF7070"}
              fontSize="13px"
              fontWeight={600}
            >
              {flows[post?.flow]?.title || "--"}
            </Typography>
          </Box>
        </Box>
      </TableCell>

      <TableCell>
        <Box display="flex" gap={1}>
          <PersonOutline
            sx={{ width: "18px", height: "18px", color: "#999" }}
          />
          <Typography fontSize="13px">
            {post?.resume_received || "0"}
          </Typography>
        </Box>
      </TableCell>
      <TableCell>
        <Box display="flex" gap={1}>
          <PersonOutline
            sx={{ width: "18px", height: "18px", color: "#999" }}
          />
          <Typography fontSize="13px" color="#37D46C">
            {post?.resume_passed || "0"}
          </Typography>
        </Box>
      </TableCell>
      <TableCell>
        {post?.expiry_date && (
          <Box display="flex" gap={1}>
            <CalendarMonthOutlined
              sx={{ width: "17px", height: "17px", color: "#999" }}
            />
            <Typography noWrap fontSize="11px">
              {/* Exp: {dayjs(post.expiry_date).format("LL")} */}
              Exp: {dayjs(post.expiry_date).format("MMM DD, YYYY")}
            </Typography>
          </Box>
        )}

        <Box display="flex" gap={1}>
          <AccessTimeOutlined
            sx={{ width: "17px", height: "17px", color: "#999" }}
          />
          <Typography noWrap fontSize="11px">
            {/* Created: {dayjs(post?.created_at).format("LL")} */}
            Created: {dayjs(post?.created_at).format("MMM DD, YYYY")}
          </Typography>
        </Box>
      </TableCell>
      <TableCell>
        <JobCriteriaPopup post={post}>
          <Box sx={{ bgcolor: "#762FDE", p: 1, borderRadius: "5px" }}>
            <Typography
              sx={{ fontFamily: "Outfit", fontSize: "13px", color: "white" }}
            >
              Criteria
            </Typography>
          </Box>
        </JobCriteriaPopup>
      </TableCell>

      <TableCell>
        <Box display="flex" gap={1} alignItems="center">
          <Box component="img" src={PROFILEICON} height={22} />
          <Typography noWrap fontSize="11px">
            {post?.recruiter?.personal_information?.first_name || "--"}
          </Typography>
        </Box>
      </TableCell>

      <TableCell>
        <Box display="flex" gap={1}>
          <Link
            component={NavLink}
            sx={{ p: 1 }}
            to={`/resume-screening-candidates/${post?.id}`}
          >
            <OpenInNewOutlined
              sx={{ width: "22px", height: "22px", color: "#0891B2" }}
            />
          </Link>

          <PopupState>
            {(popupState) => (
              <>
                <ButtonBase
                  sx={{ fontSize: "14px", gap: 0.5 }}
                  {...bindTrigger(popupState)}
                >
                  <Box
                    width="20px"
                    height="20px"
                    borderRadius="50%"
                    className="center"
                    flexDirection="column"
                    p={2}
                    bgcolor={status === "active" ? "#E8F5E9" : "#FFE1E1"}
                  >
                    {loading ? (
                      <CircularProgress color="white" size={17} />
                    ) : status === "active" ? (
                      <PlayArrow sx={{ color: "#2E7D4F" }} />
                    ) : (
                      <Pause sx={{ color: "#D32F2F" }} />
                    )}
                  </Box>
                  <KeyboardArrowDown sx={{ width: "16px", height: "16px" }} />
                </ButtonBase>
                <Menu {...bindMenu(popupState)}>
                  <MenuItem
                    onClick={() => {
                      handleStatusUpdate("active");
                      popupState.close();
                    }}
                  >
                    <Circle
                      sx={{
                        mr: 0.5,
                        color: "#2E7D4F",
                        width: "7px",
                        height: "7px",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Outfit",
                        fontWeight: 600,
                        color: "#2E7D4F",
                      }}
                    >
                      Active
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleStatusUpdate("inactive");
                      popupState.close();
                    }}
                  >
                    <Circle
                      sx={{
                        mr: 0.5,
                        color: "#D32F2F",
                        width: "7px",
                        height: "7px",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Outfit",
                        fontWeight: 600,
                        color: "#D32F2F",
                      }}
                    >
                      Inactive
                    </Typography>
                  </MenuItem>
                </Menu>
              </>
            )}
          </PopupState>
        </Box>
      </TableCell>
    </TableRow>
  );
};

const mapStateToProps = (state, props) => ({
  post: selectPostById(state, props?.id),
});

const mapDispatchToProps = {
  togglePostActiveOrInActive: togglePostActiveOrInActiveAction,
};

/* Export
============================================================================= */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(JobLiveTableViewRow));
